<template>
    <div v-if="selectedBonus" class="overview-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-24">
                    <div
                        class="overview"
                        :class="{ 'overview-collapsed': isCollapsed }"
                    >
                        <a
                            class="overview-toggle"
                            role="button"
                            @click="toggle"
                        >
                            <div class="overview-header">
                                <div class="row">
                                    <div class="col-12">
                                        <h3>{{ bonusText }} {{ monthName }}</h3>
                                    </div>
                                    <div class="col-12">
                                        <span class="float-right"
                                            >&euro;
                                            {{
                                                formatCurrency(updatedBonus)
                                            }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </a>

                        <div class="overview-content">
                            <RockOverviewSubtotal
                                :revenues="revenuesPersonal"
                            />
                            <RockOverviewRate
                                v-if="selectedMonthBonus"
                                ref="rates"
                                :selected-month-bonus="selectedMonthBonus"
                                :editable="isEditable"
                                @save="updateOverview"
                            />
                            <RockOverviewRateNew
                                v-if="
                                    selectedMonthBonus &&
                                    !selectedMonthBonus.final &&
                                    isEditable
                                "
                            />

                            <div v-if="selectedMonthBonus" class="divider" />

                            <RockOverviewSubcosts :costs="costs" />
                            <RockOverviewSummary
                                v-if="selectedMonthBonus"
                                ref="summary"
                                :selected-month-bonus="selectedMonthBonus"
                                :editable="isEditable"
                                @save="updateOverview"
                            />
                            <RockOverviewMessages
                                v-if="
                                    selectedMonthBonus &&
                                    selectedMonthBonus.final
                                "
                                :is-manager="isManager"
                                :selected-month-bonus="selectedMonthBonus"
                            />
                            <RockOverviewTotal
                                :month-name="monthName"
                                :bonus="bonus"
                                :editable="isEditable"
                                @save="saveOverview"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RockOverviewSubtotal from '@/components/RockOverviewSubtotal';
import RockOverviewSubcosts from '@/components/RockOverviewSubcosts';
import RockOverviewRate from '@/components/RockOverviewRate';
import RockOverviewRateNew from '@/components/RockOverviewRateNew';
import RockOverviewSummary from '@/components/RockOverviewSummary';
import RockOverviewTotal from '@/components/RockOverviewTotal';
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';
import RockOverviewMessages from '@/components/RockOverviewMessages';

export default {
    components: {
        RockOverviewSubtotal,
        RockOverviewSubcosts,
        RockOverviewRate,
        RockOverviewRateNew,
        RockOverviewSummary,
        RockOverviewMessages,
        RockOverviewTotal
    },
    mixins: [RockCurrencyMixin],
    props: [
        'selectedBonus',
        'selectedMonthBonus',
        'selectedEmployee',
        'isManager'
    ],
    data() {
        return {
            isCollapsed: false,
            updatedCosts: null,
            updatedRevenues: null
        };
    },
    computed: {
        getBonus: function () {
            return this.selectedMonthBonus || this.selectedBonus;
        },
        bonus: function () {
            return this.updatedBonus || this.getBonus.bonus;
        },
        costs: function () {
            return this.updatedCosts === null
                ? this.getBonus.costs
                : this.updatedCosts;
        },
        revenues: function () {
            return this.updatedRevenues === null
                ? this.getBonus.revenues
                : this.updatedRevenues;
        },
        revenuesPersonal: function () {
            return this.calculateToPersonalAmount(this.revenues);
        },
        updatedBonus: function () {
            return this.revenuesPersonal - this.costs;
        },
        isEditable: function () {
            return !this.isManager && !this.getBonus.final;
        },
        monthName: function () {
            if (
                this.selectedBonus.month >= 1 &&
                this.selectedBonus.month <= 12
            ) {
                const monthNames = [
                    'Januari',
                    'Februari',
                    'Maart',
                    'April',
                    'Mei',
                    'Juni',
                    'Juli',
                    'Augustus',
                    'September',
                    'Oktober',
                    'November',
                    'December'
                ];
                return monthNames[this.selectedBonus.month - 1];
            }
            return '';
        },
        bonusText: function () {
            if (this.getBonus.final) {
                return 'Bonus';
            }
            return 'Verwachte bonus';
        }
    },
    methods: {
        toggle() {
            this.isCollapsed = !this.isCollapsed;
        },
        updateOverview: function () {
            this.updatedCosts = this.$refs.summary.getUpdatedCosts().costs;
            this.updatedRevenues =
                this.$refs.rates.getUpdatedRevenues().revenues;
        },
        saveOverview: function () {
            this.$emit('save', {
                updatedCosts: this.$refs.summary.getUpdatedCosts(),
                updatedRevenues: this.$refs.rates.getUpdatedRevenues()
            });
        }
    }
};
</script>
